import * as React from 'react';
import { useTranslation } from 'react-i18next';
import ReactECharts from "echarts-for-react";


export default function MonitoringEChart(props) {
    const {t} = useTranslation()

    const { data, timeAggType} = props;

    const series = data.data?.map(
        (trend) => ({
            name: trend.metadata.location ?? trend.metadata.system,
            data: trend.values,
            type: 'bar',
            stack: 'x',
        })
    ) ?? [];

    const timestamps = (
        (timeAggType === "q")? 
            data?.timestamps.map((item)=>item.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01")) 
        : 
            data?.timestamps
        ) ?? [];
    

    let options = {
        grid: {
            top: '5%',
            right: 0,
            left: 60
        },
        xAxis: {
            data: timestamps,
        },
        yAxis: {
            min: 0
        },
        legend: {
            show: true,
            bottom: 0,
			left: "center",
            type: 'scroll',
            itemGap: 20,
        },
        tooltip: {
            trigger: "axis",
            confine: true,
            valueFormatter: (value) =>
                typeof value == "number" ? value.toLocaleString(navigator.language,{
                    minimumFractionDigits:2,
                    maximumFractionDigits:2
                }) : value,
        },
        series
    }

    

    return(
        <React.Fragment>
            {(Object.keys(data).length !== 0 && timestamps.length > 0) && <ReactECharts style={{ width: '100%', height: '100%' }} option={options}/> }
        </React.Fragment>
    );

};